export default "__VITE_ASSET__Bn2RguWC__"